/**
 * switch-variant-info
 *
 * Blendet den variantenspezifischen Beschreibungstext passend zur aktuell
 * gewaehlten Variante ein.
 *
 * Quelle der Wahrheit ist das versteckte input[name="id"] im Produktformular,
 * nicht die URL. Die URL zieht bei Blum erst nach, wird bei einigen
 * Interaktionen gar nicht aktualisiert, und sie ist beim ersten Rendern leer,
 * obwohl bereits eine Variante gewaehlt sein kann.
 *
 * Ersetzt die frühere Fassung, die
 *   - alle 300 ms per setInterval die URL pollte (laeuft endlos weiter),
 *   - auf die Selektoren `variant-radios` / `variant-selects` hoerte, die es
 *     im Blum-Theme nicht gibt (dort: sht-variant-radios / sht-variant-selects),
 *   - den Wrapper nur einmal bei DOMContentLoaded referenzierte und nach einem
 *     Re-Render der Produkt-Section ins Leere schrieb,
 *   - beim Seitenaufbau nie einen initialen Abgleich machte.
 */
(function () {
  'use strict';

  var WRAPPER_ID = 'variant-description-wrapper';
  var VARIANT_INPUTS = 'input.js-variant-item, select.js-variant-select-item';

  var scheduled = false;

  function productForm() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function currentVariantId() {
    var form = productForm();
    var input = form && form.querySelector('input[name="id"]');
    if (input && input.value) return String(input.value);

    // Fallback, falls das Formular (noch) nicht erreichbar ist
    var any = document.querySelector('input[name="id"]');
    return any && any.value ? String(any.value) : null;
  }

  function sync() {
    // Wrapper bei jedem Durchlauf frisch holen - Blum ersetzt die
    // Produkt-Section beim Variantenwechsel, alte Referenzen sind dann tot.
    var wrapper = document.getElementById(WRAPPER_ID);
    if (!wrapper) return;

    var id = currentVariantId();
    if (!id) return;

    var texts = wrapper.querySelectorAll('.dynamic-variant-text');
    for (var i = 0; i < texts.length; i++) {
      texts[i].style.display = texts[i].dataset.variantId === id ? 'block' : 'none';
    }
  }

  /** Mehrere Ausloeser in einem Frame zu einem Durchlauf zusammenfassen. */
  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      sync();
    });
  }

  function init() {
    sync();

    // Variantenwechsel: Event-Delegation auf document, damit es einen
    // Austausch der Produkt-Section ueberlebt. Deckt Radios (Buttons),
    // Selects (Dropdowns) und programmatische Wechsel ab, etwa durch
    // ayni-size-recommender.
    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches && event.target.matches(VARIANT_INPUTS)) {
        scheduleSync();
      }
    }, true);

    // Blum rendert die Produkt-Section beim Variantenwechsel neu und tauscht
    // dabei auch das versteckte input[name="id"] aus. Nur childList
    // beobachten: style-Aenderungen sind Attribute und loesen nicht aus, der
    // Observer kann sich also nicht selbst triggern.
    var form = productForm();
    if (form && window.MutationObserver) {
      new MutationObserver(scheduleSync).observe(form, { childList: true, subtree: true });
    }

    // Letzter Abgleich, wenn alle deferred Skripte durch sind.
    window.addEventListener('load', scheduleSync, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();